import type { SceneNode } from "../scene/model";
import { isBlockPart } from "../native/blocks";

/** Smart blocks are one tool family despite their constituent text/shapes. */
export function mixedPropertySelection(nodes: readonly SceneNode[]) {
  const families = new Set(
    nodes.map((node) => {
      if (isBlockPart(node)) return "block";
      if (["rectangle", "ellipse", "polygon", "circle"].includes(node.kind))
        return "shape";
      if (["line", "path", "polyline"].includes(node.kind)) return "path";
      return node.kind;
    }),
  );
  return families.size > 1;
}

/** Final presentation policy after individual property controllers render.
 * Commands and the right inspector keep their existing selection semantics. */
export class NativeSelectionProperties {
  private root = document.getElementById("native-context-properties")!;
  private selection = "";
  render(nodes: readonly SceneNode[]) {
    const key = nodes.map((n) => n.id).join("\0");
    if (key !== this.selection) {
      this.selection = key;
      this.root
        .querySelectorAll<HTMLElement>("[data-original-popup]")
        .forEach((p) => {
          if (p.contains(document.activeElement))
            (document.activeElement as HTMLElement).blur();
          p.hidden = true;
          p.parentElement
            ?.querySelector("button")
            ?.setAttribute("aria-expanded", "false");
        });
    }
    const mixed = mixedPropertySelection(nodes);
    this.root.dataset.mixedSelection = String(mixed);
    this.root.dataset.textRows = String(
      !mixed &&
        nodes.every((node) => node.kind === "text" && !isBlockPart(node)) &&
        !document.getElementById("native-text-compact")!.hidden,
    );
    if (mixed) {
      document.getElementById("native-compact-properties")!.hidden = false;
      document.getElementById("native-compact-align")!.hidden = false;
    }
  }
}
